/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReleaseNotesEndpointResponse
 */
export interface ReleaseNotesEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof ReleaseNotesEndpointResponse
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNotesEndpointResponse
     */
    html: string;
}

export function ReleaseNotesEndpointResponseFromJSON(json: any): ReleaseNotesEndpointResponse {
    return ReleaseNotesEndpointResponseFromJSONTyped(json, false);
}

export function ReleaseNotesEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseNotesEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': json['version'],
        'html': json['html'],
    };
}

export function ReleaseNotesEndpointResponseToJSON(value?: ReleaseNotesEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'html': value.html,
    };
}


